import { getXiServerUrl } from "@/app/_api/elevenlabs/fetch";

/**
 * Builds the signed URL used by `@elevenlabs/react` to start a template
 * preview conversation. The backend expects `template_id` and an hCaptcha
 * token as query parameters on the standard conversation endpoint.
 */
export function getTemplatePreviewSignedUrl({
  templateId,
  hcaptchaToken,
}: {
  templateId: string;
  hcaptchaToken: string;
}) {
  const url = new URL(`${getXiServerUrl()}/v1/convai/conversation/anonymous`);
  url.searchParams.set("template_id", templateId);
  url.searchParams.set("hcaptcha_token", hcaptchaToken);
  return url.toString();
}
